import { observer } from 'mobx-react-lite';
import { BookOpen, CircleNotch } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_UploadStore } from './UploadStore';
import { ThemeToggleView } from './ThemeToggleView';

export const UploadView = observer(function UploadView() {
  const store = useResolve(TOKEN_UploadStore);
  const i18n = useResolve(TOKEN_II18n);

  const onDrop = (e: React.DragEvent): void => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) void store.upload(file);
  };

  const onPick = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];
    if (file) void store.upload(file);
    e.target.value = '';
  };

  return (
    <div className="relative flex flex-1 flex-col items-center justify-center pb-10">
      <div className="absolute right-0 top-0">
        <ThemeToggleView />
      </div>
      <label
        onDrop={onDrop}
        onDragOver={(e) => e.preventDefault()}
        className="group flex w-full max-w-sm cursor-pointer flex-col items-center gap-4 rounded-3xl border border-line bg-surface px-10 py-16 text-center transition-colors hover:border-accent/50"
      >
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent/10 text-accent">
          {store.isParsing ? (
            <CircleNotch size={30} className="animate-spin" />
          ) : (
            <BookOpen size={30} weight="duotone" />
          )}
        </span>
        <span className="font-serif text-xl text-ink">
          {store.isParsing ? i18n.t('upload.parsing') : i18n.t('upload.title')}
        </span>
        <span className="text-sm text-muted">{i18n.t('upload.hint')}</span>
        <input
          type="file"
          accept=".epub,.pdf,.txt,.md,.markdown"
          className="hidden"
          onChange={onPick}
          disabled={store.isParsing}
        />
      </label>
      {store.error && <p className="mt-5 text-sm text-accent-strong">{store.error}</p>}
      <p className="mt-8 max-w-xs text-center text-xs leading-relaxed text-muted">
        {i18n.t('upload.privacy')}
      </p>
    </div>
  );
});
